// 轻量级 fetch 封装，统一处理请求与响应
import { getAccessToken } from './storage';

// 基础地址：优先使用环境变量，其次走 devServer 代理的 /api
const baseURL = process.env.VUE_APP_API_BASE_URL || '/api/';

async function request(method, url, body) {
  const token = getAccessToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  // 对登录/注册这类公开接口不附带令牌，避免过期令牌导致 401
  const isPublic = (
    url.startsWith('user/login/') ||
    url.startsWith('user/register/') ||
    url.startsWith('admin/carousel/public/')
  );
  if (token && !isPublic) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(baseURL + url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  let data;
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    try {
      data = await res.json();
    } catch (e) {
      // JSON解析失败，尝试作为文本读取
      const text = await res.text();
      throw new Error(`JSON解析失败: ${text || e.message}`);
    }
  } else {
    data = await res.text();
  }

  if (!res.ok) {
    const error = new Error('Request failed');
    error.response = { status: res.status, data };
    throw error;
  }

  return { data, status: res.status };
}

const http = {
  get: (url) => request('GET', url),
  post: (url, body) => request('POST', url, body),
  put: (url, body) => request('PUT', url, body),
};

export default http;
